import { useEffect, useRef } from 'react';
import { useSceneStore } from '../stores/sceneStore';
import { AUTOSAVE_DEBOUNCE_MS } from '@spine-workspace/shared';

export function useAutoSave() {
  const { isDirty, save } = useSceneStore();
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (!isDirty) return;

    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      save().catch(console.error);
    }, AUTOSAVE_DEBOUNCE_MS);

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [isDirty, save]);
}
